import { http, HttpResponse } from 'msw'

import { allRefills } from 'app/mocks/data/transactions/refills'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersRefillApi } from 'app/utils/transactions/refills'

import { RefillsRequest } from 'app/types/transactions/refill'

export const getAllRefills = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.transactions.REFILLS}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersRefillApi.MANAGERS,
        )

        const amountMinFilter = searchParams.get(
            searchParametersRefillApi.AMOUNT_MIN,
        )

        const amountMaxFilter = searchParams.get(
            searchParametersRefillApi.AMOUNT_MAX,
        )

        const dateStartFilter = searchParams.get(
            searchParametersRefillApi.DATE_START,
        )

        const dateEndFilter = searchParams.get(
            searchParametersRefillApi.DATE_END,
        )

        const refillFilter = searchParams.get(searchParametersRefillApi.REFILL)

        const cardNumberFilter = searchParams.get(
            searchParametersRefillApi.CARD,
        )

        const nameFilter = searchParams.get(searchParametersRefillApi.NAME)

        let allRefillsFiltered = allRefills

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allRefillsFiltered = allRefillsFiltered.filter((refill) =>
                managerIdsSplit.includes(refill.machine_user.client.id),
            )
        }

        // Date start filter
        if (dateStartFilter) {
            allRefillsFiltered = allRefillsFiltered.filter(
                (refill) => refill.date_time.split('T')[0] >= dateStartFilter,
            )
        }

        // Date end filter
        if (dateEndFilter) {
            allRefillsFiltered = allRefillsFiltered.filter(
                (refill) => refill.date_time.split('T')[0] <= dateEndFilter,
            )
        }

        // Refill ID filter
        if (refillFilter) {
            allRefillsFiltered = allRefillsFiltered.filter((refill) =>
                refill.id.toString().includes(refillFilter),
            )
        }

        // Card number filter
        if (cardNumberFilter) {
            allRefillsFiltered = allRefillsFiltered.filter((refill) =>
                refill?.pan.includes(cardNumberFilter),
            )
        }

        // Name filter
        if (nameFilter) {
            allRefillsFiltered = allRefillsFiltered.filter(
                (refill) =>
                    refill.machine_user.last_name
                        .toLowerCase()
                        .includes(nameFilter.toLowerCase()) ||
                    refill.machine_user.first_name
                        .toLowerCase()
                        .includes(nameFilter.toLowerCase()),
            )
        }

        // Get the lowest refill
        const lowerRefill =
            allRefillsFiltered.length > 0
                ? // eslint-disable-next-line unicorn/no-array-reduce
                  allRefillsFiltered.reduce(
                      (min, refill) => Math.min(min, refill.total),
                      Infinity,
                  )
                : 0

        // Get the higher refill
        // eslint-disable-next-line unicorn/no-array-reduce
        const higherRefill = allRefillsFiltered.reduce(
            (max, refill) => Math.max(max, refill.total),
            -Infinity,
        )

        // Amount minimum filter
        if (amountMinFilter) {
            allRefillsFiltered = allRefillsFiltered.filter(
                (refill) =>
                    refill.total >= Number.parseInt(amountMinFilter, 10),
            )
        }

        // Amount maximum filter
        if (amountMaxFilter) {
            allRefillsFiltered = allRefillsFiltered.filter(
                (refill) =>
                    refill.total <= Number.parseInt(amountMaxFilter, 10),
            )
        }

        // Total sum refills
        const total = allRefillsFiltered.reduce(
            (totalRefill, refill) => totalRefill + refill.total,
            0,
        )

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allRefillsFiltered.length > limit
                ? offset + limit
                : allRefillsFiltered.length

        const results = allRefillsFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allRefillsFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<RefillsRequest>({
            next,
            results,
            min_total: lowerRefill,
            max_total: higherRefill,
            total,
        })
    },
)
